import * as React from 'react';
import * as style from './style.css';
import { Label } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const DecorationLabel = () => {
  const background = 'rgba(0, 0, 0, 0.06)';
  return /*#__PURE__*/_jsx("div", {
    className: style['decoration'],
    children: /*#__PURE__*/_jsx(Label, {
      background: background,
      color: "theme-dark",
      children: "\u0421 \u043E\u0442\u0434\u0435\u043B\u043A\u043E\u0439"
    })
  });
};